import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-electronic-invoice-external',
  templateUrl: './electronic-invoice-external.component.html',
  styleUrls: ['./electronic-invoice-external.component.scss']
})
export class ElectronicInvoiceExternalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
